const addClass = (element, classNames) => {
  if (!element) {
    throw new Error("Element is required");
  }
  const classes = Array.isArray(classNames) ? classNames.filter(Boolean) : classNames.split(" ").filter(Boolean);
  element.classList.add(...classes);
};
export {
  addClass
};
//# sourceMappingURL=addClass.js.map
